import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DistrictState {
  district_data: string | number | Array;
  region_data: string | number | Array;
  division_data: string | number | Array;
  taluk_data: string | number | Array;
  village_data: string | number | Array;
  district_code: string | number | Array;
  region_code: string | number | Array;
  division_code: string | number | Array;
  taluk_code: string | number | Array;
  village_code: string | number | Array;
  disabled : boolean
}

const initialState: DistrictState = {
  district_data: [],
  region_data: [],
  division_data: [],
  taluk_data: [],
  village_data: [],

  district_code: [],
  region_code: [],
  division_code: [],
  taluk_code: [],
  village_code: [],
  disabled: false,
};

const districtSlice = createSlice({
  name: "district",
  initialState,
  reducers: {
    setSelectedDistrict: (state, action: PayloadAction<string | number>) => {
      state.district_data = action.payload;
    },
    setSelectedRegion: (state, action: PayloadAction<string | number>) => {
      state.region_data = action.payload;
    },
    setSelectedDivision: (state, action: PayloadAction<string | number>) => {
      state.division_data = action.payload;
    },
    setSelectedTaluk: (state, action: PayloadAction<string | number>) => {
      state.taluk_data = action.payload;
    },
    setSelectedVillage: (state, action: PayloadAction<string | number>) => {
      state.village_data = action.payload;
    },

    setSelectedDistrictCode: (
      state,
      action: PayloadAction<string | number>
    ) => {
      state.district_code = action.payload;
    },
    setSelectedRegionCode: (
      state,
      action: PayloadAction<string | number>
    ) => {

      state.region_code = action.payload;
    },
    setSelectedDivisionCode: (
      state,
      action: PayloadAction<string | number>
    ) => {
      state.division_code = action.payload;
    },
    setSelectedTalukCode: (state, action: PayloadAction<string | number>) => {
      state.taluk_code = action.payload;
    },
    setSelectedVillageCode: (state, action: PayloadAction<string | number>) => {
      state.village_code = action.payload;
    },
    setDisabled: (state, action: PayloadAction<boolean>) => {
      state.disabled = action.payload;
      },
  },
});

export const {
  setSelectedDistrict,
  setSelectedRegion,
  setSelectedDivision,
  setSelectedTaluk,
  setSelectedVillage,

  setSelectedDistrictCode,
  setSelectedRegionCode,
  setSelectedDivisionCode,
  setSelectedTalukCode,
  setSelectedVillageCode,
  setDisabled,
} = districtSlice.actions;


export default districtSlice.reducer;


export const hasAnyData = (slice: Record<string, any>): boolean => {
  return Object.entries(slice).some(([key, value]) => {
    if (key === "disabled" || key == "region_code") return false; // skip boolean
    if (Array.isArray(value))  return value.length > 0;
    if (typeof value === "string") return value.trim() !== "";
    if (typeof value === "number") return true; // assume any number is valid
    return false;
  });
};

